export default "__VITE_ASSET__bxX1ZV0y__"